const config = {
  API_URL: process.env.API_URL || 'http://localhost:3000',
  GOOGLE_MAPS_API_KEY: process.env.GOOGLE_MAPS_API_KEY || 'AIzaSyCR9Gy7f6SezqwywE3Q2Zkjm_46jEPDEUo',
  ENVIRONMENT: process.env.ENVIRONMENT || 'development',
  COUNTRY: process.env.COUNTRY || 'ES',
  PYLON_URL: process.env.PYLON_URL || 'https://pylon.market/form/NwEcAt/externalCode/',
  NEOCHECK_URL: process.env.NEOCHECK_URL || 'https://neocheck.net/',
  SOPHIA_URL: process.env.SOPHIA_URL || 'https://sophia-app-pontio.simplaiapps.com/',
  CRISP_CHAT: process.env.CRISP_CHAT || false,
  CRISP_CHAT_KEY: process.env.CRISP_CHAT_KEY || '0a683bdc-7c01-4171-a094-9184ffc162a6',
  MULTILANGUGE: process.env.MULTILANGUGE || false,
  I18NEXTERNAL: process.env.I18NEXTERNAL || false,
  LOOKERSTUDIO_URL:
    process.env.LOOKERSTUDIO_URL ||
    'https://lookerstudio.google.com/embed/reporting/dfe46cf0-a97c-42d3-bf6e-b5e78db5eb2a/page/p_vf8oka7ond',
  IDMAPGOOGLE: process.env.IDMAPGOOGLE || '13cdaea69788059af7e68469',
  VAPID_PUBLIC_KEY:
    process.env.VAPID_PUBLIC_KEY ||
    'BEqMrwFkdNKUWZnL9VyzlClw5459bjgPom4zgluK-AhQ-SGtIi4vmiTvCWe8XpKCFn4eYYpBsndyeY1KwNaBHlg',
  SF_ENABLED: process.env.SF_ENABLED || false,
  SF_ORG_ID: process.env.SF_ORG_ID,
  SF_DEPLOYMENT_NAME: process.env.SF_DEPLOYMENT_NAME,
  SF_BASE_URL: process.env.SF_BASE_URL,
  SF_SCRT2_URL: process.env.SF_SCRT2_URL,
  SF_BOOTSTRAP_URL: process.env.SF_BOOTSTRAP_URL,
}

export default config
